<template>
    <div class="room remote-history" v-loading="loading" ref="room">
        <RefreshBlock @refreshData="refreshData"></RefreshBlock>
        <div class="table-command-container">
            <div class="table-command">
                <span class="table-command-item-key dh-right">{{ bridgeName }}</span>
                <div class="table-command-item">
                    <span class="table-command-item-key">设备组:</span>
                    <el-select v-model="selectedStation" placeholder="请选择设备组">
                        <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                            :value="item.stationId"></el-option>
                    </el-select>
                </div>
                <div class="table-command-item">
                    <span class="table-command-item-key">数据类型:</span>
                    <el-select v-model="selectedDataType" placeholder="请选择数据类型">
                        <el-option v-for="item in dataTypeOptions" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="table-command-right">
                <el-button @click="hrefErrorRecord()" v-if="bridgeHasErrorRecord" type="primary">报警记录</el-button>
            </div>
        </div>

        <el-table :data="rowList_current" style="width: 100%" :max-height="tableMaxHeight"
            :cell-class-name="tableCellClassName">
            <el-table-column align="center" label="设备名" prop="deviceName1" width="300"></el-table-column>
            <el-table-column align="center" label="数值" prop="value1" width="100"></el-table-column>
            <el-table-column align="center" label="数据时间" prop="dataDate1"></el-table-column>
            <el-table-column align="center" label="警报等级" width="100">
                <template slot-scope="scope">
                    <el-tag class="percentage-tag" effect="dark" :type="scope.row.errorClass1">{{ scope.row.errorLevel1
                        }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="设备名" prop="deviceName2"></el-table-column>
            <el-table-column align="center" label="数值" prop="value2" width="100"></el-table-column>
            <el-table-column align="center" label="数据时间" prop="dataDate2"></el-table-column>
            <el-table-column align="center" label="警报等级" width="100">
                <template slot-scope="scope" v-if="scope.row.data2Exist">
                    <el-tag class="percentage-tag" effect="dark" :type="scope.row.errorClass2">{{ scope.row.errorLevel2
                        }}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pagination" :style="pageStyle" layout="prev, pager, next" :total="totalCount"
            :page-size="pageSize" @current-change="currentChange" :current-page.sync="currentPage"
            ref="page"></el-pagination>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
    name: "SimpleCurrentData",
    data() {
        return {
            timer: null,
            tableData: [],
            loading: false,
            shownewUser: false,
            checkUserId: "",
            totalCount: 1,
            currentPage: 1,
            pageSize: 10,
            bridgeId: "",
            bridgeName: "",
            bridgeHasErrorRecord: false,
            bridgeTranslateDict: {},
            deviceTranslateDict: {},
            deviceNameReplaceList: ["状态", "(枚举)"],
            tableMaxHeight: 777,
            clientHeight: 0,
            pageStyle: {},
            paginationHeight: 70,
            firstIndex: 0,
            lastIndex: 0,
            historyScenarioCurrentGroupNameList: [],

            dataTypeOptions: [
                {
                    id: "ALL",
                    name: "全部",
                },
                {
                    id: "OVERALL_HUMIDITY",
                    name: "湿度总均值",
                },
                {
                    id: "HUMIDITY_PASS_RATE",
                    name: "湿度合格率",
                },
                {
                    id: "DATA_VALID_RATE",
                    name: "数据有效率",
                },
                {
                    id: "HUMIDITY",
                    name: "湿度",
                },
                {
                    id: "OTHERS",
                    name: "其他",
                },
            ],

            routeBridgeId: "",
            deviceIdDeviceNameDict: {},
            stationList: [],
            selectedStation: "",
            selectedDataType: "ALL",

            rowList_all: [],
            rowList_current: [],

            dataList_all: [],
            dataList_overallHumidity: [],
            dataList_humidityPassRate: [],
            dataList_dataValidRate: [],
            dataList_humidity: [],
            dataList_others: [],
        };
    },
    computed: {
        tableSpanRowIndexDict() {
            let clientMissionIdRowIndexListDict = {};
            for (let i = 0; i < this.tableData.length; i++) {
                const mission = this.tableData[i];
                if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
                    clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
                } else {
                    clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
                }
            }

            let result = {};
            for (let clientMissionId in clientMissionIdRowIndexListDict) {
                let rowList = clientMissionIdRowIndexListDict[clientMissionId];
                result[Math.min.apply(null, rowList)] = rowList.length;
            }

            return result;
        },
        ...mapGetters({
            isAdmin: "getIsAdmin",
            bridgeList: "getBridgeList",
        }),
    },
    mounted() {
        this.loading = true;

        window.onresize = () => {
            this.clientHeight = document.documentElement.clientHeight;
        };
        this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
        this.pageStyle = {
            left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };

        this.initializeStationAndGetData();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    watch: {
        clientHeight(newVal, oldVal) {
            this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
        },
        totalCount() {
            this.$nextTick().then(() => {
                this.pageStyle = {
                    left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
                };
            });
        },
        $route(route) {
            if (this.$route.query.bridgeId !== this.routeBridgeId) {
                this.initializeStationAndGetData();
            }
        },
        selectedDataType() {
            this.dataTypeOnChange();
        },
        selectedStation() {
            this.loading = true;
            this.currentPage = 1;
            this.getDataList();
        },
    },
    methods: {
        initializeStationAndGetData() {
            this.loading = true;
            if (this.timer) {
                clearInterval(this.timer);
            }

            if (!this.isAdmin) {
                this.$alert("您登陆的用户无法使用本页面", {
                    confirmButtonText: "确定",
                    showClose: true,
                    type: "error",
                    callback: (action) => {
                        // console.log('stop');
                        // this.resultObjectList = [];
                    },
                });

                return;
            }

            this.routeBridgeId = this.$route.query.bridgeId;
            let routeBridgeIdConfirmed = false;
            this.bridgeList.forEach((bridge) => {
                if (bridge.id === this.routeBridgeId) {
                    routeBridgeIdConfirmed = true;
                    //break
                    return false;
                }
            });

            if (!routeBridgeIdConfirmed) {
                this.$alert("无效的桥梁编号", {
                    confirmButtonText: "确定",
                    showClose: true,
                    type: "error",
                    callback: (action) => {
                        // console.log('stop');
                        // this.resultObjectList = [];
                    },
                });

                return;
            }

            this.timer = setInterval(() => {
                this.getDataList();
            }, this.REFRESH_SECOND);

            this.stationList = [];
            this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
                this.bridgeHasErrorRecord = res.data.recordDataErrorReporForWebpage;
                res.data.stationList.forEach((stationItem) => {
                    this.stationList.push({
                        stationId: stationItem.stationId,
                        stationName: stationItem.stationName,
                    });
                });

                this.$nextTick(() => {
                    if (this.stationList.length > 0) {
                        this.selectedStation = this.stationList[0].stationId;
                    }

                    this.bridgeName = res.data.bridgeName;
                    this.currentPage = 1;
                    this.getDataList();
                });
            });
        },
        hrefErrorRecord() {
            let url = this.$route.path;
            let firstSlash = url.indexOf("/");
            if (firstSlash < 0) {
                return;
            }
            let secondSlash = url.indexOf("/", firstSlash + 1);
            if (secondSlash < 0) {
                return;
            }

            let result = url.slice(0, secondSlash);
            result = result + "/errorRecord?bridgeId=" + this.routeBridgeId + "&stationId=" + this.selectedStation;
            this.$router.push(result);
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 3) {
                return "table-row-spliter";
            } else {
                return "";
            }
        },
        dataTypeOnChange() {
            this.filterDataByDataType();
            this.currentChange(1);
        },
        filterDataByDataType() {
            let val = this.selectedDataType;

            if (val === "ALL") {
                this.rowList_all = this.assembleDataRow(this.dataList_all);
            } else if (val === "OVERALL_HUMIDITY") {
                this.rowList_all = this.assembleDataRow(this.dataList_overallHumidity);
            } else if (val === "HUMIDITY_PASS_RATE") {
                this.rowList_all = this.assembleDataRow(this.dataList_humidityPassRate);
            } else if (val === "DATA_VALID_RATE") {
                this.rowList_all = this.assembleDataRow(this.dataList_dataValidRate);
            } else if (val === "HUMIDITY") {
                this.rowList_all = this.assembleDataRow(this.dataList_humidity);
            } else if (val === "OTHERS") {
                this.rowList_all = this.assembleDataRow(this.dataList_others);
            } else {
                this.rowList_all = [];
            }

            this.totalCount = this.rowList_all.length;
        },
        refreshData() {
            this.loading = true;
            this.getDataList();
        },
        currentChange(index) {
            this.loading = true;
            this.currentPage = index;

            let result = [];
            let pageStart = (this.currentPage - 1) * this.pageSize;
            for (let i = 0; i < this.pageSize; i++) {
                let actualIndex = pageStart + i;
                if (actualIndex >= this.rowList_all.length) {
                    break;
                }

                result.push(this.rowList_all[actualIndex]);
            }

            this.rowList_current = result;

            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
        getDataCount() {
            this.$http.get("/user/GetUserLoginRecordCount?userId=" + this.routeUserId).then((res) => {
                this.totalCount = res.data.count;
            });
        },
        getDataList() {
            this.loading = true;

            let dataTypeOptionList = [
                {
                    id: "ALL",
                    name: "全部",
                },
            ];

            if (!this.selectedStation || this.selectedStation === "") {
                this.dataList_all = [];
                this.dataList_overallHumidity = [];
                this.dataList_humidityPassRate = [];
                this.dataList_dataValidRate = [];
                this.dataList_humidity = [];
                this.dataList_others = [];

                this.dataTypeOptions = dataTypeOptionList;

                this.filterDataByDataType();
                this.currentChange(this.currentPage);
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                return;
            }

            let metaQuery = this.$http.get("/bridge/stationInfo?stationId=" + this.selectedStation);
            let dataQuery = this.$http.get("/deviceData/AverageStation?stationId=" + this.selectedStation);
            this.$http.all([metaQuery, dataQuery]).then(
                this.$http.spread((metaRes, dataRes) => {
                    this.deviceIdDeviceNameDict = {};
                    metaRes.data.deviceList.forEach((deviceItem) => {
                        this.deviceIdDeviceNameDict[deviceItem.deviceId] = deviceItem.deviceName;
                    });

                    this.dataList_all = [];
                    this.dataList_overallHumidity = [];
                    this.dataList_humidityPassRate = [];
                    this.dataList_dataValidRate = [];
                    this.dataList_humidity = [];
                    this.dataList_others = [];

                    for (let dataId in dataRes.data) {
                        let rawDataItem = dataRes.data[dataId];

                        let dataItem = {
                            deviceId: rawDataItem.deviceId,
                            value: rawDataItem.value,
                            dataDate: rawDataItem.dataDate,
                            StatisticsDate: rawDataItem.StatisticsDate,
                            StatisticsDateOverall: rawDataItem.StatisticsDateOverall,
                        };
                        if (this.deviceIdDeviceNameDict[dataItem.deviceId]) {
                            dataItem.deviceName = this.deviceIdDeviceNameDict[dataItem.deviceId];
                        }
                        if (rawDataItem.errorLevel.toLowerCase() === "normal") {
                            dataItem.errorLevel = "正常";
                            dataItem.errorClass = "primary";
                        } else if (rawDataItem.errorLevel.toLowerCase() === "warning") {
                            dataItem.errorLevel = "中断";
                            dataItem.errorClass = "warning";
                        } else if (rawDataItem.errorLevel.toLowerCase() === "error") {
                            dataItem.errorLevel = "超限";
                            dataItem.errorClass = "danger";
                        }
                        dataItem.dataDate = dateTimeToString(newtonsoftJsonToDate(rawDataItem.dataDate), "YY年MM月dd日 HH:mm");

                        this.dataList_all.push(dataItem);
                        if (dataItem.deviceName.indexOf("湿度总均值") >= 0) {
                            this.dataList_overallHumidity.push(dataItem);
                        } else if (dataItem.deviceName.indexOf("湿度合格率") >= 0) {
                            this.dataList_humidityPassRate.push(dataItem);
                        } else if (dataItem.deviceName.indexOf("数据有效率") >= 0) {
                            this.dataList_dataValidRate.push(dataItem);
                        } else if (dataItem.deviceName.indexOf("湿度") >= 0) {
                            this.dataList_humidity.push(dataItem);
                        } else {
                            this.dataList_others.push(dataItem);
                        }

                        try {
                            dataItem.value = Math.round(dataItem.value * 100.0) / 100.0;
                        } catch {
                            //pass
                        }

                        if (rawDataItem.errorLevel.toLowerCase() === "warning") {
                            dataItem.value = "--";
                            dataItem.dataDate = "--";
                        }
                    }

                    if (this.dataList_overallHumidity.length > 0) {
                        dataTypeOptionList.push({
                            id: "OVERALL_HUMIDITY",
                            name: "湿度总均值数据",
                        });
                    }
                    if (this.dataList_humidityPassRate.length > 0) {
                        dataTypeOptionList.push({
                            id: "HUMIDITY_PASS_RATE",
                            name: "湿度合格率",
                        });
                    }
                    if (this.dataList_dataValidRate.length > 0) {
                        dataTypeOptionList.push({
                            id: "DATA_VALID_RATE",
                            name: "数据有效率",
                        });
                    }
                    if (this.dataList_humidity.length > 0) {
                        dataTypeOptionList.push({
                            id: "HUMIDITY",
                            name: "湿度",
                        });
                    }
                    if (this.dataList_others.length > 0) {
                        dataTypeOptionList.push({
                            id: "OTHERS",
                            name: "其他数据",
                        });
                    }

                    this.dataTypeOptions = dataTypeOptionList;

                    this.filterDataByDataType();
                    this.currentChange(this.currentPage);
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                })
            );
        },
        assembleDataRow(dataList) {
            let result = [];
            for (let i = 0; i < dataList.length; i += 2) {
                let rawItem = dataList[i];
                let dataDate1 = rawItem.StatisticsDate;
                if (rawItem.StatisticsDateOverall && rawItem.StatisticsDateOverall !== "") {
                    dataDate1 = rawItem.StatisticsDateOverall;
                }

                let item = {
                    deviceName1: rawItem.deviceName,
                    value1: rawItem.value,
                    dataDate1: dataDate1,
                    errorLevel1: rawItem.errorLevel,
                    errorClass1: rawItem.errorClass,
                };

                rawItem = dataList[i + 1];
                if (rawItem) {
                    let dataDate2 = rawItem.StatisticsDate;
                    if (rawItem.StatisticsDateOverall && rawItem.StatisticsDateOverall !== "") {
                        dataDate2 = rawItem.StatisticsDateOverall;
                    }

                    item.deviceName2 = rawItem.deviceName;
                    item.value2 = rawItem.value;
                    item.dataDate2 = dataDate2;
                    item.errorLevel2 = rawItem.errorLevel;
                    item.errorClass2 = rawItem.errorClass;
                    item.data2Exist = true;
                } else {
                    item.data2Exist = false;
                }

                result.push(item);
            }

            return result;
        },
        translateBridgeName(bridgeId) {
            for (let bridge of this.bridgeList) {
                if (bridge.id === bridgeId) {
                    return bridge.name;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.remote-history {
    margin-top: 20px;
    background-color: #fff;
    padding: 20px;
    // height: 784px !important;
    height: calc(100% - 20px) !important;
    position: relative;

    .table-command-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .table-command {
        display: flex;
    }

    .table-command-right {
        display: flex;
        margin-right: 20px;
    }

    .table-command-item-key {
        margin-right: 10px;
        margin-left: 20px;
        margin-top: 10px;
    }

    .pagination {
        position: absolute;
        bottom: 0;
    }
}

.status-tag {
    cursor: pointer;
}

.table-button {
    margin-bottom: 10px;
    margin-left: 10px;
}

.dialog-form-input {
    width: 80%;
}

.error-level-tag {
    min-width: 75px;
}

::v-deep .table-row-spliter {
    border-right: 1px solid #ebeff0;
}

::v-deep .el-pagination {
    text-align: center;
}
</style>
